
// window.addEventListener("load", function () {

//   gsap.registerPlugin(ScrollTrigger);

//   const titles = document.querySelectorAll(".title-anim");

//   titles.forEach((title) => {

//     const text = title.textContent.trim();

//     title.innerHTML = text.split("").map(letter =>
//       `<span class="char">${letter === " " ? "&nbsp;" : letter}</span>`
//     ).join("");

//     const chars = title.querySelectorAll(".char");

//     gsap.fromTo(chars,
//       { y: 20, opacity: 0 },
//       {
//         y: 0,
//         opacity: 1,
//         duration: 0.8,
//         stagger: 0.05,
//         ease: "power3.out",
//         scrollTrigger: {
//           trigger: title,   // 🔥 Important: trigger each title individually
//           start: "top 85%",
//           toggleActions: "play none none none"
//         }
//       }
//     );

//   });

// });



$(document).ready(function(){
  gsap.registerPlugin(ScrollTrigger);
  $("h2").each(function(index, el){
    const split = new SplitText(el, { type: "words,chars" });
    gsap.fromTo(split.chars,
      { scale: 0 },
      {
        scale: 1,
        duration: 1,
        stagger: 0.02,
        ease: "back.out(1.7)",
        scrollTrigger: {
          trigger: el,
          start: "top 80%", // trigger when heading is 80% into viewport
          once: true        // play only once
        },
      }
    );
  });
});

